import api from "../helpers/axios";

class VectorService {
  /**
   * Soft delete documents in Qdrant vector database
   * @param {Array} files - Array of file objects with file_url property
   * @returns {Promise<Object>} Vector deletion response with success details
   */
  async softDeleteDocuments(files) {
    try {
      // Validate files have file_url property
      const invalidFiles = files.filter((file) => !file.file_url);
      if (invalidFiles.length > 0) {
        throw new Error(
          `${invalidFiles.length} files missing required blob URL data`
        );
      }

      // Map files to the required API format
      const payload = {
        files: files.map((file) => ({
          blob_url: file.file_url,
        })),
      };

      const response = await api.put("/vector/soft-delete", payload);

      // Validate response and check for partial failures
      const result = response.data;

      if (!result.success || result.successful_deletions < result.total_files) {
        const failedResults = (result.results || []).filter((r) => !r.success);
        const allAlreadyGone = failedResults.length > 0 && failedResults.every(
          (r) => r.message === 'No documents found matching the criteria'
        );
        if (!allAlreadyGone) {
          const failedCount = result.total_files - result.successful_deletions;
          throw new Error(
            `Failed to remove ${failedCount} of ${result.total_files} files from search index. Process stopped for data consistency.`
          );
        }
      }

      return result;
    } catch (error) {
      console.error("Error deleting documents from vector database:", error);

      // Re-throw with more specific error messages
      if (error.message.includes("files missing required")) {
        throw error; // Re-throw validation errors as-is
      } else if (error.message.includes("Failed to remove")) {
        throw error; // Re-throw partial failure errors as-is
      } else {
        throw new Error("Error connecting to search index service");
      }
    }
  }
}

export default new VectorService();
